import React, { useState ,useEffect} from 'react';
import {
    Button,
    FormControl,
    FormLabel,
    Icon,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
    Select,
    Text

} from '@chakra-ui/react'
import { VscAdd } from 'react-icons/vsc';
import { useDispatch,useSelector } from 'react-redux';
import { createPersona, getPersonas } from '../../features/personaSlice';
import { getListSelectCiudad } from '../../features/ciudadSlice';
export const ModalAgregarPersona = ({ page, perPage }) => {
    const dispatch = useDispatch();

    const isValidEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };
    const [emailError, setEmailError] = useState('');

    const [isModalOpen, setIsModalOpen] = useState(false);

    const initialValues = { 
        nombre: '',
        apellido: '',
        cedula: '',
        fechaIngreso: '',
        direccion: '',
        celular: '',
        email: '',
        fechaNacimiento: '',
        estado: true, 
        ciudadId: '' 
    };
    const [indice, setIndice] = useState(initialValues);

    const { ciudades } = useSelector((state) => state.ciudades);

    useEffect(() => {
        if (isModalOpen) {
            dispatch(getListSelectCiudad());
        }
    }, [isModalOpen, dispatch]);


    const handleModalOpen = () => setIsModalOpen(true);
    const handleModalClose = () => {
        setIsModalOpen(false);
        setIndice(initialValues);
    };

    const handleSave = () => {
        dispatch(createPersona(indice)).then(() =>{
            dispatch(getPersonas({ page, perPage })); // Usa los valores pasados como props y Actualiza 
            setIsModalOpen(false)
            setIndice(initialValues)
        });
       
    }


    return (
        <>
            <Button
                colorScheme="blue"
                _dark={{ bg: "blue.500", color: "white", _hover: { bg: "blue.600" }}}
                aria-label="Agregar"
                leftIcon={<Icon as={VscAdd} fontSize="lg" />}
                variant="solid"
                rounded={'xl'}
                onClick={handleModalOpen}
            >
                Nuevo Registro
            </Button>
            <Modal isOpen={isModalOpen} onClose={handleModalClose} size="5xl" isCentered>
                <ModalOverlay 
                    bg="rgba(11,15,25, 0.8)"
                    backdropFilter='auto'
                    backdropBlur='2px'
                />
                <ModalContent _dark={{ bg: "primary.1000" }} borderRadius="2xl">
                    <ModalHeader textAlign="center">AGREGAR NUEVA PERSONA</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Stack spacing={4} direction={{ base: "column", lg: "row"}} justifyContent="space-between" p={4}>
                            <FormControl isRequired>
                                <FormLabel fontWeight="semibold">NOMBRE</FormLabel>
                                    <Input
                                        placeholder="Ingrese el nombre de la persna"
                                        type="text"
                                        onChange={(e) => setIndice({ ...indice, nombre: e.target.value })}
                                    />
                            </FormControl>

                            <FormControl>
                                <FormLabel fontWeight="semibold">APELLIDO</FormLabel>
                                    <Input
                                        placeholder="Ingrese el apellido de la persona"
                                        type="text"
                                        onChange={(e) => setIndice({ ...indice, apellido: e.target.value })}
                                    />
                            </FormControl>
                            
                        </Stack>

                        <Stack spacing={4} direction={{ base: "column", lg: "row"}} justifyContent="space-between" p={4}>
                            <FormControl isRequired>
                                <FormLabel fontWeight="semibold">CEDULA</FormLabel>
                                    <Input
                                        placeholder="Ingrese la cedula"
                                        type="text"
                                        onChange={(e) => setIndice({ ...indice, cedula: e.target.value })}
                                    />
                            </FormControl>

                            <FormControl>
                                <FormLabel fontWeight={'semibold'}>FECHA DE NACIMIENTO</FormLabel>
                                <Input
                                    type="date"
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setIndice({ ...indice, fechaNacimiento: value ? value : null });
                                    }}
                                />
                            </FormControl>  
                        </Stack>

                        <Stack spacing={4} direction={{ base: "column", lg: "row"}} justifyContent="space-between" p={4}>
                            <FormControl>
                                <FormLabel fontWeight="semibold">DIRECCION</FormLabel>
                                    <Input
                                        placeholder="Ingrese la dirección"
                                        type="text"
                                        onChange={(e) => setIndice({ ...indice, direccion: e.target.value })}
                                    />
                            </FormControl>
                        </Stack>

                        <Stack spacing={4} direction={{ base: "column", lg: "row"}} justifyContent="space-between" p={4}>
                            <FormControl isRequired>
                                <FormLabel fontWeight={'semibold'}>CIUDAD</FormLabel>
                                <Select
                                    placeholder="Seleccione una ciudad"
                                    onChange={(e) => setIndice({ ...indice, ciudadId: e.target.value })}
                                    value={indice.ciudadId || ''}
                                >
                                    {ciudades.map((ciudad) => (
                                        <option key={ciudad.id} value={ciudad.id}>
                                            {ciudad.descripcion}
                                        </option>
                                    ))}
                                </Select>
                            </FormControl>
                           <FormControl isInvalid={!!emailError}>
                                <FormLabel fontWeight="semibold">EMAIL</FormLabel>
                                <Input
                                    placeholder="Ingrese el email"
                                    type="email"
                                    value={indice.email || ''}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setIndice({ ...indice, email: value });

                                        if (!isValidEmail(value)) {
                                            setEmailError('El correo no es válido');
                                        } else {
                                            setEmailError('');
                                        }
                                    }}
                                />
                                {emailError && (
                                    <Text color="red.500" fontSize="sm" mt={1}>
                                        {emailError}
                                    </Text>
                                )}
                            </FormControl>
                        </Stack>

                        <Stack spacing={4} direction={{ base: "column", lg: "row"}} justifyContent="space-between" p={4}>
                            <FormControl>
                                <FormLabel fontWeight="semibold">CELULAR</FormLabel>
                                    <Input
                                        placeholder="Ingrese el # de celular"
                                        type="text"
                                        onChange={(e) => setIndice({ ...indice, celular: e.target.value })}
                                    />
                            </FormControl>

                            <FormControl>
                                <FormLabel fontWeight={'semibold'}>FECHA DE INGRESO</FormLabel>
                                <Input
                                    type="date"
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setIndice({ ...indice, fechaIngreso: value ? value : null });
                                    }}
                                />
                            </FormControl>            
                        </Stack>
                    
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="red" _dark={{ bg: "red.500", color: "white", _hover: { bg: "red.600" } }} size="lg" mr={3} onClick={handleModalClose} borderRadius="xl">
                            CANCELAR
                        </Button>
                        <Button
                            colorScheme="blue"
                            _dark={{ bg: "blue.500", color: "white", _hover: { bg: "blue.600" } }}
                            size="lg"
                            mr={3}
                            onClick={handleSave}
                            borderRadius="xl"
                            disabled={!indice.nombre.trim() || !indice.ciudadId || !indice.cedula.trim()}
                        >
                            GUARDAR
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}
